import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.isMobile ? _setup.CoreBottomSheet : _setup.CoreDialog,
    _vm._b(
      {
        tag: "component",
        attrs: { "data-qa": "referral_for_service_modal" },
        scopedSlots: _vm._u(
          [
            !_setup.isMobile
              ? {
                  key: "prependBtn",
                  fn: function ({ btnProps }) {
                    return [
                      _c(
                        VBtn,
                        _vm._b(
                          {
                            on: {
                              click: function ($event) {
                                _setup.invasiveServiceInfoStore.isOpenedReferralForServiceModal = false
                              },
                            },
                          },
                          "v-btn",
                          btnProps,
                          false
                        ),
                        [
                          _c("span", {
                            staticClass: "ui-icon-close-not-a-circle",
                          }),
                        ]
                      ),
                    ]
                  },
                }
              : null,
            {
              key: "actions",
              fn: function () {
                return [
                  _c(
                    VBtn,
                    {
                      class: _setup.isMobile
                        ? "order-1 w-100"
                        : "w-0 flex-grow-1",
                      attrs: {
                        "data-qa": "referral_for_service_modal_btn_no",
                        color: "bg-primary",
                        depressed: "",
                      },
                      on: { click: _setup.handleClickNo },
                    },
                    [
                      _c("span", { staticClass: "primary--text" }, [
                        _vm._v("\n        Нет\n      "),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    VBtn,
                    {
                      class: _setup.isMobile ? "w-100" : "w-0 flex-grow-1",
                      attrs: {
                        "data-qa": "referral_for_service_modal_btn_yes",
                        color: "bg-primary",
                        depressed: "",
                      },
                      on: { click: _setup.handleClickYes },
                    },
                    [
                      _c("span", { staticClass: "primary--text" }, [
                        _vm._v("\n        Да\n      "),
                      ]),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
        model: {
          value:
            _setup.invasiveServiceInfoStore.isOpenedReferralForServiceModal,
          callback: function ($$v) {
            _vm.$set(
              _setup.invasiveServiceInfoStore,
              "isOpenedReferralForServiceModal",
              $$v
            )
          },
          expression:
            "invasiveServiceInfoStore.isOpenedReferralForServiceModal ",
        },
      },
      "component",
      _setup.isMobile ? { slotActionsClass: "flex-column" } : { size: "lg" },
      false
    ),
    [
      _vm._v(" "),
      _c(VImg, {
        staticClass: "mx-auto mb-5",
        attrs: {
          alt: "",
          src: "/static/_v1/pd/pictures/appointment/referral-for-service.svg",
          height: "150",
          width: "150",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "text-h6 text--text text-center mx-auto mb-2",
          attrs: { "data-qa": "preliminary_consultation_title" },
        },
        [_vm._v("\n    У вас есть направление на процедуру?\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "text-body-1 text-secondary--text text-center mx-auto",
          attrs: { "data-qa": "preliminary_consultation_subtitle" },
        },
        [_vm._v("\n    Нужно будет загрузить скан или фото направления\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }